import ReactRailsUJS from 'react_ujs';
import '@styles/main';
import { installImplicitSubmitSuppressor } from '@utils/suppressImplicitFormSubmit';

const frontendContext = require.context('../features', true, /^(?!.*\.md$)/);
ReactRailsUJS.useContext(frontendContext);

// Legacy sprockets pages inject data-react-class markup into DOM built after
// page load (e.g. DataTables rows) and re-mount it via this global.
window.ReactRailsUJS = ReactRailsUJS;

// Delegated from document, so it survives Turbolinks navigation and applies to
// dynamically added rows. No-op on pages with no opted-in form.
installImplicitSubmitSuppressor();
